import get from 'lodash/get'
import { fetchPolicy as globalFetchPolicy } from 'config/graphql'
import { transformData } from './utils'

export default async (client, query, options) => {
	if(!client) {
		const queryName = get('query', 'definitions[0].name.value')
		console.error(`Can not execute query ${queryName || ''}. Apollo client was not provided.`)
		return {}
	}
	if(!query) {
		console.error(`Can not execute query. GraphQl query was not provided.`)
		return {}
	}

	const { data, ...rest } = await client.query({
		query,
		fetchPolicy: globalFetchPolicy,
		errorPolicy: 'all',
		notifyOnNetworkStatusChange: true,
		...options
	})
	const { data: transformedData, ...dataInfo } = transformData(data)

	return {
		...rest,
		...dataInfo,
		data: transformedData,
		hasData: !!Object.keys(transformedData).length
	}
}
